import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    showCreateDisciplineDrawer: false,
    editingDisciplineId: null,
}

const disciplineSlice = createSlice({
    name: 'discipline',
    initialState,
    reducers: {
        setShowCreateDisciplineDrawer: (state, action) => {
            state.showCreateDisciplineDrawer = action.payload
        },
        setEditingDisciplineId: (state, action) => {
            state.editingDisciplineId = action.payload
        },
        reset: () => initialState,
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const disciplineActions = disciplineSlice.actions

export default disciplineSlice.reducer 